module.exports = new __parcel__URL__("checkout.cc97b3de.svg").toString();